import axios from 'axios';
import _ from 'lodash';
import { getTokenFromStorage } from '../../utils/token';
import { queryStringify } from '../../utils/url';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  paramsSerializer: (params) => {
    if (params && typeof params === 'object') {
      return queryStringify(params) || '';
    }
    return '';
  },
});

api.defaults.headers.common['Accept'] = 'application/json';

/**
 * Adding token in params of the url
 *
 * NOTE: This should be added in headers but don't know why Authorization headers is not supported
 */
api.interceptors.request.use((config) => {
  const token = getTokenFromStorage();
  if (token) {
    if (config.params) {
      _.assign(config.params, { token });
    } else {
      config.params = { token };
    }
  }
  return config;
});
